import React, { useState, useEffect } from "react";
import "./Navbar.css";
import API_URL from "../apiConfig";

const API_BASE_URL = API_URL;

const DEFAULT_CATEGORIES = [
  "Kurti",
  "Lehenga",
  "Sarees",
  "Palazo sets",
  "Blouses",
  "Ethnic",
].map((name, index) => ({ _id: `default-${index}`, name }));

const Navbar = ({ onNavClick, userRole, onSearch }) => {
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/categories`);
        if (res.ok) {
          const data = await res.json();
          setCategories(data);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (searchInput.trim().length > 1) {
        try {
          const res = await fetch(
            `${API_BASE_URL}/api/products?search=${encodeURIComponent(searchInput)}`,
          );
          if (res.ok) {
            const data = await res.json();

            // Also filter categories that match the search
            const matchedCategories = categories
              .filter((cat) =>
                cat.name.toLowerCase().includes(searchInput.toLowerCase()),
              )
              .map((cat) => ({ ...cat, isCategory: true }));

            setSuggestions([...matchedCategories, ...data].slice(0, 10)); // Limit to 10
            setShowSuggestions(true);
          }
        } catch (err) {
          console.error("Error fetching suggestions:", err);
        }
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    };

    const timeoutId = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(timeoutId);
  }, [searchInput, categories]);

  useEffect(() => {
    const handleClearSearch = () => {
      setSearchInput("");
      setSuggestions([]);
      setShowSuggestions(false);
    };
    window.addEventListener("clearSearch", handleClearSearch);
    return () => window.removeEventListener("clearSearch", handleClearSearch);
  }, []);

  const handleSearchSubmit = (e) => {
    if (e.key === "Enter") {
      onSearch(searchInput);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    const query = suggestion.isCategory ? suggestion.name : suggestion.name;
    setSearchInput(query);
    onSearch(query);
    setShowSuggestions(false);
  };

  return (
    <nav className="navbar">
      <div className="container nav-content">
        <div className="nav-left">
          <div className="logo" onClick={() => onNavClick("home")}>
            {/* <img
              src="/below2000.png"
              alt="BELOW2000"
              style={{ height: "60px", filter: "brightness(1.2)" }}
            /> */}
            <span>BELOW2000</span>
          </div>
          <ul className="nav-links">
            {categories.map((cat) => (
              <li key={cat._id}>
                <span onClick={() => onNavClick("home")}>
                  {cat.name.toUpperCase()}
                </span>
              </li>
            ))}
            {userRole === "vendor" && (
              <li>
                <span
                  onClick={() => onNavClick("customize")}
                  style={{ color: "#ff3f6c", fontWeight: "800" }}
                >
                  CUSTOMIZE
                </span>
              </li>
            )}
          </ul>
        </div>

        <div className="nav-center">
          <div className="search-container">
            <div className="search-bar">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="search-icon"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>

              <input
                type="text"
                placeholder="Search on Below2000"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={handleSearchSubmit}
                onFocus={() =>
                  searchInput.trim().length > 1 && setShowSuggestions(true)
                }
              />
            </div>

            {showSuggestions && suggestions.length > 0 && (
              <div className="suggestions-dropdown">
                {suggestions.map((item) => (
                  <div
                    key={item._id}
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(item)}
                  >
                    <div className="suggestion-icon-mini">
                      {item.isCategory ? (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                        </svg>
                      ) : (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <circle cx="11" cy="11" r="8"></circle>
                          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                      )}
                    </div>
                    <div className="suggestion-info">
                      <span className="suggestion-name">{item.name}</span>
                      {item.isCategory ? (
                        <span className="suggestion-type">Category</span>
                      ) : (
                        <span className="suggestion-category">
                          in {item.category}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {showSuggestions &&
              suggestions.length === 0 &&
              searchInput.trim().length > 1 && (
                <div className="suggestions-dropdown">
                  <div className="suggestion-item no-results">
                    No products found for "{searchInput}"
                  </div>
                </div>
              )}
          </div>
        </div>

        <div className="nav-right">
          <div className="nav-icon-group">
            <div
              className="nav-icon-item"
              onClick={() => {
                if (userRole === "vendor") onNavClick("vendor");
                else if (userRole) onNavClick("profile");
                else onNavClick("login");
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>
                {userRole === "vendor"
                  ? "Dashboard"
                  : userRole
                    ? "Profile"
                    : "Login"}
              </span>
            </div>
            <div
              className="nav-icon-item"
              onClick={() => onNavClick("wishlist")}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
              </svg>
              <span>Wishlist</span>
            </div>
            <div className="nav-icon-item" onClick={() => onNavClick("cart")}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
                <path d="M3 6h18"></path>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              <span>Bag</span>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
